export default "__VITE_ASSET__a97494c9__"